import {useEffect} from "react";
import {useParams} from "react-router-dom";
import traitify, {Components} from "traitify-widgets";
import useTraitifyWidgets from "lib/hooks/use-traitify-widgets";

export default function Survey() {
  const {id: assessmentID} = useParams();
  const widgetProps = useTraitifyWidgets();

  useEffect(() => {
    traitify.listener.on("Survey.Finished", () => { window.location.href = `/results/${assessmentID}`; });
  }, []);

  if(!widgetProps) { return; }

  widgetProps.assessmentID = assessmentID;
  widgetProps.options.survey = {showInstructions: true};

  return (
    <div className="container">
      <section className="max-w-screen-lg mx-auto">
        <Components.Container {...widgetProps}>
          <Components.Survey.Container />
        </Components.Container>
      </section>
    </div>
  );
}
